import NOTIFICATION_TYPES from './types';

interface State {
	open: boolean;
	variant: string;
	message: string;
}

const INITIAL_STATE: State = {
	open: false,
	variant: '',
	message: '',
};

const reducer = (state: State = INITIAL_STATE, action: any) => {
	const { payload, type } = action;
	switch (type) {
		case NOTIFICATION_TYPES.ADD:
			return {
				...state,
				open: true,
				variant: payload.variant,
				message: payload.message,
			};
		case NOTIFICATION_TYPES.CLEAN:
			return INITIAL_STATE;
		default:
			return state;
	}
};

export default reducer;
